import { appStore } from '@app/AppStore';
import { UndoOperationModel } from '@app/Models/WebApiModels';

export interface IOperation {
    operationId: string;
    time: number;
    name: string;
    isChangeLogEnabled: boolean;
}

export default class LocalStorageService {
    static addOperationToStack(operationId: string, name: string) {
        const item = localStorage.getItem('operationStack');
        let operationStack: IOperation[] = item ? JSON.parse(item) : [];
        operationStack = this.clearOld(operationStack);

        if (!operationId) return operationStack.length;

        operationStack.push({
            operationId: operationId,
            time: new Date().getTime(),
            name: name,
            isChangeLogEnabled: !appStore.isChangeLogOff,
        });
        if (operationStack.length > 100) {
            operationStack.splice(0, operationStack.length - 100);
        }
        localStorage.setItem('operationStack', JSON.stringify(operationStack));
        return operationStack.length;
    }

    static getLastOperation():string | null {
        const item = localStorage.getItem('operationStack');
        if (!item) return null;
        let operationStack: IOperation[] = JSON.parse(item);
        operationStack = this.clearOld(operationStack);
        const lastOperation = operationStack.pop();
        localStorage.setItem('operationStack', JSON.stringify(operationStack));
        return (lastOperation && lastOperation.operationId) || null;
    }

    static pickTopOperationDetails(): { operationId: string | undefined, operationName: string } | null {
        const item = localStorage.getItem('operationStack');
        if (!item) return null;
        let operationStack: IOperation[] = JSON.parse(item);
        operationStack = this.clearOld(operationStack);
        const lastOperation = operationStack.pop();
        return {
            operationId: lastOperation?.operationId,
            operationName: lastOperation?.name ?? ''
        };
    }

    static getOperationsAmount() {
        return LocalStorageService.getOperations().length;
    }

    static getOperations() {
        const item = localStorage.getItem('operationStack');
        let operationStack: IOperation[] = item ? JSON.parse(item) : [];
        operationStack = this.clearOld(operationStack, true);
        return operationStack;
    }

    static clearOld(operationStack: Array<IOperation>, needSave?: boolean): IOperation[] {
        if (!operationStack || operationStack.length < 1) return operationStack;
        const time = new Date().getTime() - 24 * 60 * 60 * 1000;
        const index = operationStack.findIndex((operation) => !!operation.time && operation.time > time);
        let stack = operationStack;
        if (index > 0) {
            stack.splice(0, index);
            if (needSave) localStorage.setItem('operationStack', JSON.stringify(operationStack));
        } else if (index < 0) {
            stack = [];
            if (needSave) localStorage.removeItem('operationStack');
        }
        return stack;
    }

    static addOperationListToStack(operations: UndoOperationModel[]) {
        const operationStack: IOperation[] = [];
        const time = new Date().getTime() - 24 * 60 * 60 * 1000;
        operations.forEach((operation: UndoOperationModel) => {
            const operationTime = operation.operationDateUtc.getTime();
            if (operationTime > time) {
                operationStack.push({
                    operationId: operation.operationId,
                    time: operationTime,
                    name: operation.name,
                    isChangeLogEnabled: operation.isChangeLogEnabled
                });
            }
        });
        localStorage.setItem('operationStack', JSON.stringify(operationStack));
        return operationStack.length;
    }
}
